import { alias, createModelSchema, custom, deserialize, list, serialize, SKIP } from "serializr";
import { Cloneable } from "@/common/Cloneable";

export class LevelTrackLevelPattern extends Cloneable {
    constructor() {
        super();

        this._artefact = "";
        this._rect = [[0, 0], [0, 0]];
        this._rotate = 0;
    }

    get artefact() {
        return this._artefact;
    }

    set artefact(value) {
        this._artefact = value;
    }

    get rect() {
        return this._rect;
    }

    set rect(value) {
        this._rect = value;
    }

    get rotate() {
        return this._rotate;
    }

    set rotate(value) {
        this._rotate = value;
    }

    valid() {
        const validRotations = [0, 90, 180, 270];

        if (typeof this.artefact !== 'string' || this.artefact.trim() === '') {
            return false;
        }

        if (!Array.isArray(this.rect) || this.rect.length !== 2 || this.rect.some(coord => !Array.isArray(coord) || coord.length !== 2)) {
            return false;
        }

        if (!validRotations.includes(this.rotate)) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.artefact && (!this.rect || this.rect.length === 0) && (this.rotate === undefined || this.rotate === null);
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelTrackLevelPattern());
        } else if (target instanceof LevelTrackLevelPattern) {
            return super.clone(target);
        } else {
            return undefined;
        }
    }

    static schema() {
        return custom(
            (v) => (v && !v.empty() ? serialize(LevelTrackLevelPattern, v) : SKIP),
            (v) => deserialize(LevelTrackLevelPattern, v)
        );
    }
}

createModelSchema(LevelTrackLevelPattern, {
    _artefact: alias("artefact", toString()),
    _rect: alias("rect", list(list(toNumber()))),
    _rotate: alias("rotate", toNumber()),
});

function toNumber() {
    return custom(
        (value) => Number(value),
        (value) => Number(value),
    );
}

function toString() {
    return custom(
        (value) => String(value),
        (value) => String(value),
    );
}
